import "./App.css";
import React, { useMemo } from "react";
import * as anchor from "@project-serum/anchor";
import Home from "./Home";
import { DEFAULT_TIMEOUT } from "./connection";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletExtensionWallet,
  getSolletWallet,
} from "@solana/wallet-adapter-wallets";


import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";

import { createTheme, ThemeProvider } from "@material-ui/core";
import Typography from '@mui/material/Typography';

import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Avatar from '@mui/material/Avatar';
import TwitterIcon from '@mui/icons-material/Twitter';
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton';

import About from './components/About';
import Descriptions from "./components/Descriptions";
import FAQ from './components/FAQ';


const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const getCandyMachineId = (): anchor.web3.PublicKey | undefined => {
  try {
    return new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID!);
  } catch (e) {
    console.log("Failed to construct CandyMachineId", e);
    return undefined;
  }
};

let error: string | undefined = undefined;

if (process.env.REACT_APP_SOLANA_NETWORK === undefined) {
  error =
    "Your REACT_APP_SOLANA_NETWORK value in the .env file doesn't look right! The options are devnet and mainnet-beta!";
} else if (process.env.REACT_APP_SOLANA_RPC_HOST === undefined) {
  error =
    "Your REACT_APP_SOLANA_RPC_HOST value in the .env file doesn't look right! Make sure you enter it in as a plain-text url (i.e., https://metaplex.devnet.rpcpool.com/)";
}

const candyMachineId = getCandyMachineId();
const network = (process.env.REACT_APP_SOLANA_NETWORK ??
  "devnet") as WalletAdapterNetwork;
const rpcHost =
  process.env.REACT_APP_SOLANA_RPC_HOST ?? anchor.web3.clusterApiUrl("devnet");
const connection = new anchor.web3.Connection(rpcHost);

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSlopeWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    []
  );
  
  // Tabs
  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  
  return (
    <ThemeProvider theme={theme}>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletDialogProvider>
       
          <Box sx={{ width: '100%', typography: 'body1', color: 'white' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: '#151A1F' }}>
                <TabList onChange={handleChange} aria-label="tabs">
                  <Avatar alt="HB" src="https://i.imgur.com/6Y1d2Wx.png" variant="square" sx={{ width: 48, height: 48, marginTop: 0, marginLeft: 0}}/>
                  <Typography 
                    variant="h5" 
                    noWrap
                    component="a"
                    style={{paddingTop: '0.5rem', paddingRight: '0.5rem', paddingLeft: '0.1rem', fontFamily: 'sans-serif', letterSpacing: '0.02rem', fontWeight: 500, fontSize: 24, color: '#ffff'}}
                  >
                    HYPERBOREA
                  </Typography>
                  <Tab label="Mint" value="1" style={{color: '#ffff', width: '4rem'}}/>
                  <Tab label="About" value="2" style={{color: '#ffff', width: '4rem'}}/>
                  <Tab label="Altair Properties" value="3" style={{color: '#ffff', width: '12rem'}}/>
                  <Tab label="FAQ" value="5" style={{color: '#ffff', width: '4rem'}}/>
                </TabList>
              </Box>
              <TabPanel value="1">
                <Home
                  candyMachineId={candyMachineId}
                  connection={connection}
                  txTimeout={DEFAULT_TIMEOUT}
                  rpcHost={rpcHost}
                  network={network}
                  error={error}
                />  
              </TabPanel>
              <TabPanel value="2"><About/></TabPanel>
              <TabPanel value="3"><Descriptions/></TabPanel>
              <TabPanel value="5"><FAQ/></TabPanel>
            </TabContext>
            <Box sx={{marginTop: 5, background: '#151A1F', padding: 2}}>
              <p style={{fontSize: 12, color: 'lightgrey'}}>Contacts:</p>
   

                  <IconButton href="https://twitter.com/HyperboreaLVTN">
                    <TwitterIcon sx={{width: 36, height: 36, marginRight: 1, color: 'white'}}/> <p style={{fontSize: 10, color: 'lightgrey', marginRight: 32}}>https://twitter.com/HyperboreaLVTN</p>
                  </IconButton>
                  <IconButton>
                    <EmailIcon sx={{width: 36, height: 36, marginRight: 1, color: 'white'}}/> <p style={{fontSize: 10, color: 'lightgrey', marginRight: 32}}>hyperboreaproject@gmail.com</p> 
                  </IconButton>
                  <IconButton href="https://discord.gg/yBDzmB9dBx">
                    <p style={{fontSize: 10, color: 'lightgrey', marginRight: 32}}> DISCORD: https://discord.gg/yBDzmB9dBx </p> 
                  </IconButton>
                  <IconButton href="https://forms.gle/vRpbEQYWvfdutJvG9">
                    <p style={{fontSize: 10, color: 'lightgrey', marginRight: 32}}> WHITELIST FORM: https://forms.gle/vRpbEQYWvfdutJvG9 </p> 
                  </IconButton>
                  <p style={{fontSize: 10, color: 'lightgrey', marginRight: 32}}>As seen on:</p>
                  <IconButton href='https://nftcalendar.io/'>
                  <img style={{width: '164px', height: '164px'}}
                    src={`https://i.imgur.com/sgQCNJW.png?w=100&h=225&fit=crop&auto=format`}
                    srcSet={`https://i.imgur.com/sgQCNJW.png?w=200&h=225&fit=crop&auto=format&dpr=2 2x`}
                    alt='nft-calendar'
                    loading="lazy"
                  />
                  </IconButton>
              
            </Box>
          </Box>
          </WalletDialogProvider>
        </WalletProvider>
      </ConnectionProvider>
      
    </ThemeProvider>
  );
};

export default App;
